<template>

    <div class="w-100 h-100 ps-3 pe-3 py-1 tx-font bg-color-white tx-color-steel" style="min-width: 100vw;">
      <v-toolbar height="50" class="hidden-sm-down tx-color-steel" color="#444444">
        <v-spacer></v-spacer>
        
        <v-btn class="ma-2 text-none" prepend-icon="mdi-account-group-outline" @click="goTo('user-profile')">
          <LanguagePlaceholder default-text="User Management" />
        </v-btn>
          
        <v-btn class="ma-2 text-none" prepend-icon="mdi-clipboard-account-outline"
          @click="systemStore.routerTo('contact-us')">
          <LanguagePlaceholder default-text="Contact Us" />
        </v-btn>
        
        <v-btn class="ma-2 text-none" prepend-icon="mdi-help-circle-outline"
          @click="systemStore.routerTo('faq')">
          <LanguagePlaceholder default-text="Help Center" />
        </v-btn>
  
        <v-btn class="ma-2 text-none" prepend-icon="mdi-web">
          <LanguagePlaceholder default-text="Languages" />
          <v-menu activator="parent" transition="scale-transition" location="bottom">
              <v-list>
                  <v-list-item v-for="(item, index) in systemStore.getData('languages')" :key="index"
                      :value="index" @click="selectLanguage(item)">
                      <v-list-item-title>
                          <LanguagePlaceholder :default-text="item.language" />
                      </v-list-item-title>
                  </v-list-item>
              </v-list>
          </v-menu>
        </v-btn>
          
        <v-btn v-if="systemStore.userDetail.userType.trim() === 'TIC_Admin' && systemStore.userDetail.affinityId === 987654321" class="ma-2 text-none" prepend-icon="mdi-view-dashboard-outline" @click="systemStore.routerTo('admin')">
          <LanguagePlaceholder default-text="Admin" />
        </v-btn>
          
        <v-btn class="ma-2 text-none" prepend-icon="mdi-logout-variant" @click="logout">
          <LanguagePlaceholder default-text="Log Out" />
        </v-btn>        
          
        <v-spacer></v-spacer>
      </v-toolbar>
  
      <div class="d-flex justify-center w-100 TopLogos">
        <div class="d-flex justify-center w-50">
          <v-img
            :width="200"
            aspect-ratio="16/9"
            src="https://dellpartnerincentives.com/siteassets/Images/Global/logoDell.png"
          ></v-img>
          <v-img
            :width="200"
            aspect-ratio="16/9"
            src="https://dellpartnerincentives.com/siteassets/Images/Global/logoWindows11.png"
          ></v-img>
          <v-img
            :width="200"
            aspect-ratio="16/9"
            src="https://dellpartnerincentives.com/siteassets/Images/Global/logoIntel.png"
          ></v-img>
          <v-img
            :width="200"
            aspect-ratio="16/9"       
            src="https://dellpartnerincentives.com/siteassets/Images/Global/logoMicrosoft.png"
          ></v-img>
          <SpecialButton 
            class="hidden-sm-down ms-14"
            icon-color="#0672CB"
            icon="mdi-account-outline"
            :icon-size="40"
            :button-width="200" :title="systemStore.userDetail.fullname"
            :sub-title="systemStore.userDetail.userType == 'Partner' ? 'Authorized Reseller' : systemStore.userDetail.userType"
            @click="goTo('user-profile')"
            tabindex="0"
            @keydown.enter="goTo('user-profile')" />
          <SpecialButton v-if="systemStore.userDetail.userType == 'Partner'"
            class="ms-5"
            icon-color="#0672CB"
            icon="mdi-currency-usd"
            :icon-size="40"
            :button-width="320"
            title="Rewards this Incentive Period: $0.00"
            sub-title="" :isSelectable="false" />
        </div>    
      </div>    
  
      <div fluid class="pa-0">
        <v-card variant="flat" tile class="my-5 bg-color-quartz tx-color-steel hidden-sm-down px-0">
          <v-row justify="center">
              <v-btn size="small" variant="text" class="text-none" color="#6E6E6E" stacked v-for="o, idx in menuOptions"
                  :prepend-icon="o.icon" @click="systemStore.routerTo(o.routerPath)">
                  <LanguagePlaceholder is-html
                                  :default-text="o.text" />
                  <v-menu v-if="o.subOptions !== undefined && o.subOptions.length > 0" activator="parent"
                      transition="scale-transition" location="bottom">
                      <v-list>
                          <v-list-item v-for="m in o.subOptions" @click="systemStore.routerTo(m.routerPath)">
                              <v-list-item-title>
                                  <LanguagePlaceholder :default-text="m.title" />
                              </v-list-item-title>
                          </v-list-item>
                      </v-list>
                  </v-menu>
              </v-btn>
          </v-row>
        </v-card>
      </div>
  
      <router-view v-slot="{ Component, route }">
        <transition name="router-anim">
            <component :is="Component" />
        </transition>
      </router-view>
  
      <v-footer height="80" class="hidden-sm-down" color="#444444">
        <v-row justify="center" no-gutters>
          <v-btn class="ma-2 text-none" variant="text" @click="systemStore.routerTo('terms-of-use')">
            <LanguagePlaceholder is-html position="fixed"
                default-text="Terms Of Use" />
          </v-btn>
          <v-btn class="ma-2 text-none" variant="text" @click="systemStore.routerTo('privacy-statement')">
            <LanguagePlaceholder is-html position="fixed"
                default-text="Privacy Statement" />
          </v-btn>
          <v-btn class="ma-2 text-none" variant="text" @click="systemStore.routerTo('cookies-information')">
            <LanguagePlaceholder is-html position="fixed"
                default-text="Cookies Information" />
          </v-btn>
        </v-row>
      </v-footer>
  
    </div>

</template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import router from '../router'
  import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
  import { useSystemStore } from '@/stores/system'
  import { useAuthStore } from '@/stores/auth'
  import SpecialButton from '@/components/SpecialButton.vue'
  
  const authStore = useAuthStore()
  const systemStore = useSystemStore()
  const showBottomSheet = ref(false)
  
  const menuOptions = ref([])
  const sideOptions = ref([])
  
  const configMenuOptions = () => {
      menuOptions.value = []
  
      let reportsSubOptions = [];
  
      const dellInternalReportAccess = ['TIC_Admin', 'TP', 'PAM', 'Dell Marketing']   
      const hasDellInternalReportAccess = dellInternalReportAccess.indexOf(systemStore.userDetail.userType.trim()) > -1 ? true : false
      
      if (hasDellInternalReportAccess) {
          reportsSubOptions.push({ title: 'Dell Internal', routerPath: 'dell-internal-reports' });
      }
  
      reportsSubOptions.push(
          { title: 'Distributor Dashboard', routerPath: 'distributor-dashboard' },
          { title: 'Partner Performance', routerPath: 'partner-performance' },
          { title: 'Redemption Balance Report', routerPath: 'distributor-redemption' },
          { title: 'Distributor E-Voucher Report', routerPath: 'distributor-evoucher-report' },
          { title: 'Credit Note Report', routerPath: 'creditnote-report' },
          { title: 'Bonus Dashboard Partner', routerPath: 'bonus-dashboard-partner' },
          { title: 'Bonus Dashboard Distributor', routerPath: 'bonus-dashboard-distributor' },
      )
  
      if (systemStore.userDetail.userType.trim() === 'Partner') {
          menuOptions.value.push({ text: 'Home', toolbar: 'primary', icon: 'mdi-home-outline', routerPath: 'home-partner' })
          menuOptions.value.push({ text: 'About RISE', toolbar: 'primary', icon: 'mdi-information-outline', routerPath: 'home-about-rise-partner' })
          // menuOptions.value.push({
          //     text: 'Redemption', toolbar: 'primary', icon: 'mdi-clipboard-list-outline', subOptions: [
          //         { title: 'Redeem My Rewards', routerPath: 'redemption' },
          //         { title: 'Redemption Summary', routerPath: 'redemption-summary' },
          //     ]
          // })
          menuOptions.value.push({ text: 'Rewards Center', toolbar: 'primary', icon: 'mdi-clipboard-list-outline', routerPath: 'redemption' })
          menuOptions.value.push({ text: 'Peripheral Promotions', toolbar: 'primary', icon: 'mdi-mouse-outline', routerPath: 'dncp' })
          menuOptions.value.push({ text: 'Eligible Products', toolbar: 'primary', icon: 'mdi-tag-outline', routerPath: 'home-eligible-products' })
          menuOptions.value.push({ text: 'Rewards Paid', toolbar: 'primary', icon: 'mdi-currency-usd', routerPath: 'partner-rewards-paid' })
          menuOptions.value.push({ text: 'My Performance', toolbar: 'primary', icon: 'mdi-finance', routerPath: 'my-performance' })
          menuOptions.value.push({ text: 'My Bonus Dashboard', toolbar: 'primary', icon: 'mdi-view-dashboard-outline', routerPath: 'bonus-dashboard-partner' })
          menuOptions.value.push({ text: 'Rewards Calculator', toolbar: 'primary', icon: 'mdi-calculator', routerPath: 'rewards-calculator' })
          menuOptions.value.push({ text: 'News', toolbar: 'primary', icon: 'mdi-wifi', routerPath: 'news' })
      } else if (systemStore.userDetail.userType.trim() === 'Distributor') {
          menuOptions.value.push({ text: 'Home', toolbar: 'primary', icon: 'mdi-home-outline', routerPath: 'home-distributor' })
          menuOptions.value.push({ text: 'About RISE', toolbar: 'primary', icon: 'mdi-information-outline', routerPath: 'home-about-rise-distributor' })
          menuOptions.value.push({ text: 'Eligible Products', toolbar: 'primary', icon: 'mdi-tag-outline', routerPath: 'home-eligible-products' })
          menuOptions.value.push({ text: 'Rewards Calculator', toolbar: 'primary', icon: 'mdi-calculator', routerPath: 'rewards-calculator' })
          menuOptions.value.push({ text: 'Marketing Assets', toolbar: 'primary', icon: 'mdi-arrow-collapse-down', routerPath: 'marketing-assets' })
          menuOptions.value.push({
              text: 'Reports', toolbar: 'primary', icon: 'mdi-chart-box-multiple-outline', subOptions: [
                  { title: 'Distributor Dashboard', routerPath: 'distributor-dashboard' },
                  { title: 'Partner Performance', routerPath: 'partner-performance' },
                  { title: 'Redemption Balance Report', routerPath: 'distributor-redemption' },
                  { title: 'E-Voucher Report', routerPath: 'distributor-evoucher-report' },
                  { title: 'Credit Note Report', routerPath: 'creditnote-report' },
                  { title: 'Bonus Dashboard Distributor', routerPath: 'bonus-dashboard-distributor' },
              ]
          })
          menuOptions.value.push({ text: 'News', toolbar: 'primary', icon: 'mdi-wifi', routerPath: 'news' })
  
      } else if (systemStore.userDetail.userType.trim() === 'Dell'
          || systemStore.userDetail.userType.trim() === 'TP'
          || systemStore.userDetail.userType.trim() === 'PAM'
          || systemStore.userDetail.userType.trim() === 'Dell Marketing'
          || systemStore.userDetail.userType.trim() === 'TIC_Admin'
      ) {
          menuOptions.value.push({ text: 'Home Partner', toolbar: 'primary', icon: 'mdi-home-outline', routerPath: 'home-partner' })
          menuOptions.value.push({ text: 'Home Distributor', toolbar: 'primary', icon: 'mdi-home-outline', routerPath: 'home-distributor' })
          menuOptions.value.push({ text: 'About RISE Partner', toolbar: 'primary', icon: 'mdi-information-outline', routerPath: 'home-about-rise-partner' })
          menuOptions.value.push({ text: 'About RISE Distributor', toolbar: 'primary', icon: 'mdi-information-outline', routerPath: 'home-about-rise-distributor' })        
          // menuOptions.value.push({
          //     text: 'Redemption', toolbar: 'primary', icon: 'mdi-clipboard-list-outline', subOptions: [
          //         { title: 'Redeem My Rewards', routerPath: 'redemption' },
          //         { title: 'Redemption Summary', routerPath: 'redemption-summary' },
          //     ]
          // })
          menuOptions.value.push({ text: 'Rewards Center', toolbar: 'primary', icon: 'mdi-clipboard-list-outline', routerPath: 'redemption' })
          menuOptions.value.push({ text: 'Peripheral Promotions', toolbar: 'primary', icon: 'mdi-mouse-outline', routerPath: 'dncp' })
          menuOptions.value.push({ text: 'Eligible Products', toolbar: 'primary', icon: 'mdi-tag-outline', routerPath: 'home-eligible-products' })
          menuOptions.value.push({ text: 'Rewards Paid', toolbar: 'primary', icon: 'mdi-currency-usd', routerPath: 'partner-rewards-paid' })
          menuOptions.value.push({ text: 'My Performance', toolbar: 'primary', icon: 'mdi-finance', routerPath: 'my-performance' })
          menuOptions.value.push({ text: 'Rewards Calculator', toolbar: 'primary', icon: 'mdi-calculator', routerPath: 'rewards-calculator' })
          menuOptions.value.push({ text: 'Marketing Assets', toolbar: 'primary', icon: 'mdi-arrow-collapse-down', routerPath: 'marketing-assets' })
          menuOptions.value.push({ text: 'Reports', toolbar: 'primary', icon: 'mdi-chart-box-multiple-outline', subOptions: reportsSubOptions })
          menuOptions.value.push({ text: 'News', toolbar: 'primary', icon: 'mdi-wifi', routerPath: 'news' })
      }
  
      sideOptions.value = [...menuOptions.value]
  
      if (hasDellInternalReportAccess) {
          reportsSubOptions.push({ title: 'Google Analytics', routerPath: 'google-analytics' });
      }
  
      sideOptions.value.push({ text: 'User Management', toolbar: 'primary', icon: 'mdi-account-group-outline', routerPath: 'user-profile' })
      sideOptions.value.push({ text: 'My Messages', toolbar: 'primary', icon: 'mdi-email-outline', routerPath: 'messages' })
      sideOptions.value.push({ text: 'Contact Us', toolbar: 'primary', icon: 'mdi-clipboard-account-outline', routerPath: 'contact-us' })
      sideOptions.value.push({ text: 'Help Center', toolbar: 'primary', icon: 'mdi-help-circle-outline', routerPath: 'faq' })
      sideOptions.value.push({ text: 'Languages', toolbar: 'primary', icon: 'mdi-web' })
  
      sideOptions.value.push({ text: 'Log Out', toolbar: 'primary', icon: 'mdi-logout-variant-outline', routerPath: 'logout' })
      
      sideOptions.value.push({ text: 'Terms Of Use', toolbar: 'primary', icon: '', routerPath: 'terms-of-use' })
      sideOptions.value.push({ text: 'Privacy Statement', toolbar: 'primary', icon: '', routerPath: 'privacy-statement' })
      sideOptions.value.push({ text: 'Cookies Information', toolbar: 'primary', icon: '', routerPath: 'cookies-information' })
  
  }
  
  onMounted(() => {
      configMenuOptions()
  
      // query('set', 'user_properties', {
      //     affinity_id: systemStore.userDetail.affinityId,
      //     user_type: systemStore.userDetail.userType,
      // })
  })
  
  const selectLanguage = (item) => {
      showBottomSheet.value = false
  
      systemStore.selectedLanguage = item.iso.toLowerCase()
  
      systemStore.updateUserLanguage(0, systemStore.selectedLanguage).then(() => {
          systemStore.showMessage('User default language updated (' + systemStore.selectedLanguage.toUpperCase() + ')', { color: 'success' })
          localStorage.setItem("selectedLanguage", systemStore.selectedLanguage)
      })
  }
  
  const goTo = (routeName) => {
      if (routeName !== undefined) {
          router.push({ name: routeName })
          showBottomSheet.value = false
      }
  }
  
  const logout = () => {
      authStore.logout()
  }
  
  </script>
  
  <style scoped>
  
    .TopLogos{
      background-color:#eeeeee;
      color:#6e6e6e;
      padding:20px 0px;
    }
  
  </style>